import { render, staticRenderFns } from "./CustomizeMetalAD.vue?vue&type=template&id=caf83d46&scoped=true"
import script from "./CustomizeMetalAD.vue?vue&type=script&lang=js"
export * from "./CustomizeMetalAD.vue?vue&type=script&lang=js"
import style0 from "./CustomizeMetalAD.vue?vue&type=style&index=0&id=caf83d46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caf83d46",
  null
  
)

export default component.exports